import axiosClient from '@/api/core/axiosClient';

export const ordersApi = {
    // Storefront endpoints
    getUserOrders: async (params?: { page?: number; limit?: number }) => {
        return await axiosClient.get('/storefront/orders', { params });
    },

    getOrderById: async (id: string) => {
        return await axiosClient.get(`/storefront/orders/${id}`);
    },

    getOrderByNumber: async (orderNumber: string) => {
        return await axiosClient.get(`/storefront/orders/number/${orderNumber}`);
    },

    createOrder: async (data: any) => {
        return await axiosClient.post('/storefront/orders', data);
    },

    cancelOrder: async (id: string) => {
        return await axiosClient.post(`/storefront/orders/${id}/cancel`, {});
    },

    getPaymentStatus: async (id: string) => {
        return await axiosClient.get(`/storefront/orders/${id}/payment-status`);
    },

    resumePayment: async (id: string) => {
        return await axiosClient.post(`/storefront/orders/${id}/resume-payment`, {});
    },

    // Admin endpoints
    adminGetAllOrders: async (params?: any) => {
        return await axiosClient.get('/admin/orders', { params });
    },

    adminUpdateOrderStatus: async (id: string, status: string) => {
        return await axiosClient.put(`/admin/orders/${id}/status`, { status });
    },

    adminAddOrderComment: async (id: string, comment: string) => {
        return await axiosClient.post(`/admin/orders/${id}/comments`, { content: comment });
    },
};
